import fetchHTTP from 'Utils/fetchHTTP';
import browerContext from 'Utils/browser';
import { datadogRum } from '@datadog/browser-rum';

export const PUSHER_CONFIG_URL = '/v1/protected/pusher/config';

const getApplication = () => fetchHTTP('/v1/protected/applications', {
  method: 'GET',
}).then((res) => {
  const { customer_id: customerId } = res;
  datadogRum.setUser({ id: customerId });
  if (window.DD_LOGS) {
    window.DD_LOGS.setLoggerGlobalContext({
      view: {
        data: {
          customer: {
            id: customerId,
          },
        },
      },
    });
  }
  return res;
});

const getTotalApplications = () => fetchHTTP('/v1/protected/customer/applications/total?status[]=paid&status[]=loan', {
  method: 'GET',
});

const createApplication = (data) => {
  const objectJoin = { ...data, browser: { ...browerContext() } };
  return fetchHTTP('/v1/protected/applications', {
    data: objectJoin,
    method: 'POST',
  });
};

const cancelApplication = data => fetchHTTP('/v1/protected/applications', {
  data,
  method: 'DELETE',
});

const getPaymentApplication = () => fetchHTTP('/v1/protected/applications/payment', {
  method: 'GET',
});

const getWow = () => fetchHTTP('/v1/protected/wow_moment', {
  method: 'GET',
});

const postWow = () => fetchHTTP('/v1/protected/wow_moment', {
  method: 'POST',
});

const getRecaCashInstallments = () => fetchHTTP('/v1/protected/recas/cash_installments', {
  method: 'GET',
});

const getPusherConfig = () => fetchHTTP(PUSHER_CONFIG_URL, {
  method: 'GET',
});

const appendLogBehavior = data => fetchHTTP('/v1/protected/log_behavior', {
  data,
  method: 'PUT',
});

const getDownpaymentCancellationSurvey = () => fetchHTTP('/v1/protected/surveys/downpayment_cancel_reason', {
  method: 'GET',
});

const getTransactionDetails = () => fetchHTTP('/v1/protected/applications/transaction_details', {
  method: 'GET',
});

export {
  getApplication,
  createApplication,
  cancelApplication,
  getPaymentApplication,
  getWow,
  postWow,
  getPusherConfig,
  getRecaCashInstallments,
  appendLogBehavior,
  getTotalApplications,
  getDownpaymentCancellationSurvey,
  getTransactionDetails,
};
